import { render, staticRenderFns } from "./TableScrollRow.vue?vue&type=template&id=5cc64742&scoped=true&"
import script from "./TableScrollRow.vue?vue&type=script&lang=js&"
export * from "./TableScrollRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc64742",
  null
  
)

export default component.exports